import React from 'react';
import { ErrorState } from '../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface WhatIfErrorProps {
  error: Error;
  onRetry: () => void;
}

export const WhatIfError = ({ error, onRetry }: WhatIfErrorProps) => (
  <Box flexGrow={1} display="flex" alignItems="center" justifyContent="center">
    <ErrorState message={error.message} onAction={onRetry} />
  </Box>
);
